/** @format */
import { Context, createContext } from 'react';

import {
    AddToBasketProduct,
    Basket,
    BasketProduct,
    GetBasketOptions, // eslint-disable-next-line boundaries/element-types -- I think this should be allowed, needs a discussion and re-visit
} from '@toucan/client/core/basket';

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface MiniBasketContextProps {
    visible: boolean;
}

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface BasketContextProps {
    basketModelSlugs: Record<number, string>;
    basket: Basket;
    miniBasket: MiniBasketContextProps;
    getBasket: (options?: GetBasketOptions) => Promise<Basket | null>;
    setMiniBasketVisible: (arg: boolean) => void;
    addToBasket: (
        product: AddToBasketProduct,
        quantity: number
    ) => Promise<void>;
    isLoading: boolean;
    removeFromBasket: (product: BasketProduct, quantity: number) => void;
    isInitialised: boolean;
    isBasketValid: () => boolean;
    removeUnavailableBasketItems: () => void;
}

export const BasketContext: Context<BasketContextProps> = createContext(
    {} as BasketContextProps
);

BasketContext.displayName = 'BasketContext';
